import { MOS_PACKAGE } from '@mxa-argos/constants/mos';
import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';

// Must run after phase B: granting the DIALER role restarts the package process, killing a
// running MOS.
export function launchMOSStep(): ForjaStep {
  return {
    name: 'launch MOS',
    verify: (device) => device.isAppInForeground(MOS_PACKAGE),
    apply: async (device) => {
      await device.shell('input', 'keyevent', 'KEYCODE_WAKEUP');
      await device.shell('wm', 'dismiss-keyguard');
      await device.shell(
        'monkey',
        '-p',
        MOS_PACKAGE,
        '-c',
        'android.intent.category.LAUNCHER',
        '1',
      );
    },
    verifyTimeoutMs: 30_000,
  };
}
